import { fontSize, fontWeight, theme } from "@tm/utility/global";
import styled from "styled-components";

export const Wrap = styled.div`
  padding: 0 16px;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid transparent;
  border-radius: 16px;
  padding: 12px;
  background: linear-gradient(${theme.whiteText}, ${theme.whiteText})
      padding-box,
    linear-gradient(90deg, ${theme.redText4}, ${theme.lightRed}) border-box;
  gap: 8px;
`;

export const Icon = styled.img`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  object-fit: contain;
`;

export const TextCol = styled.span`
  flex: 1;
  min-width: 0;
  font-size: ${fontSize.font12};
  font-weight: ${fontWeight.regular};
  color: ${theme.greyText};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
`;

export const Cta = styled.button`
  border: none;
  background: none;
  font-size: ${fontSize.font12};
  font-weight: ${fontWeight.bold};
  color: ${theme.blueText};
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
  white-space: nowrap;
`;
